// The settings the API gave the SPA at start-up (client-config), for the parts
// of the shell that need them, such as the way back to MIST.Web.
import { createContext, useContext } from 'react';

import type { ClientConfigResponse } from '../api/generated/ClientConfigResponse';

export const ClientConfigContext = createContext<ClientConfigResponse | null>(null);

/** Where MIST.Web is, when the shop floor was told. */
export const useMistWebUrl = (): string | null => useContext(ClientConfigContext)?.mistWebUrl ?? null;
